// Wordmark "SEO REVUE" — text-only, pairs with Mascot component for the logo lockup
export function Wordmark({ className = "h-8", text = "#FAF0DE", accent = "#FF8C42" }) {
  return (
    <svg viewBox="0 0 320 60" className={className} xmlns="http://www.w3.org/2000/svg" aria-label="SEO Revue">
      <text
        x="0" y="46"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontSize="52" fontWeight="900" letterSpacing="-2" fill={text}
      >
        SEO
      </text>
      <circle cx="100" cy="42" r="4" fill={accent} />
      <text
        x="116" y="46"
        fontFamily="'Cabinet Grotesk', sans-serif"
        fontSize="52" fontWeight="900" letterSpacing="-2" fill={text}
      >
        REVUE
      </text>
    </svg>
  );
}

export default Wordmark;
